
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';

export const Route = createFileRoute('/logout')({
    component: LogoutPage,
})

function LogoutPage() {

    return (
        <div className="p-2">
            <h3>{t('label.logout')}</h3>
        </div>
    )

}
